<template>
  <maker-layout>
    <div>
      <statuses-list :maker="maker" :admin="canUpdateStatuses">
        <template slot="beforeList" v-if="!canUpdateStatuses">
          <v-alert dense text outlined type="info" class="text-left">
            Ce prestataire gère lui-même ces informations
          </v-alert>
        </template>
      </statuses-list>
    </div>
  </maker-layout>
</template>

<script>
import { mapState } from 'vuex';
import MakerLayout from '@/views/settings/makers/MakerLayout.vue';
import StatusesList from '@/views/settings/StatusesList.vue';

export default {
  data: () => ({
  }),
  computed: {
    ...mapState(`ui/settingsMakers`, {
      maker: `currentAdminMaker`,
    }),
    canUpdateStatuses() {
      return this.maker?.slug === ``;
    },
  },
  components: {
    MakerLayout,
    StatusesList,
  },
};
</script>
